<template>
  <div class="" v-resize="onResize">
    <h1 class="py-6">{{ $t("goods.remains") }}</h1>
    <v-row class="mx-0 w-100 mb-5">
      <v-col xs="6" md="4" class="pa-0 mx-0">
        <v-card class="pa-3 ma-0" elevation="0">
          <v-text-field
              outlined
              :placeholder="$t('viewStorages.search_placeholder')"
              append-icon="fa-times"
              hide-details
              @click:append="search = ''"
              v-model="search"
          ></v-text-field>
        </v-card>
      </v-col>
      <v-col xs="3" md="4" class="pa-0 mx-0 ml-1">
        <v-card class="pa-3 ma-0" elevation="0">
          <v-select
              :disabled="!fetched"
              :readonly="!fetched"
              v-model="selectedStoragesList"
              :item-disabled="()=>!fetched"
              :items="storages"
              hide-details

              chips
              :label="$t('common.storages')"
              multiple
              outlined
              height="30"
              item-text="name"
              item-value="id"
              return-object
          >
            <template v-slot:prepend-item>
              <v-list-item
                  :disabled="!fetched"
                  ripple
                  @mousedown.prevent
                  @click="toggleSelectedStorages"
              >
                <v-list-item-action>
                  <v-icon
                      :disabled="!fetched"
                      :color="
                      selectedStoragesList.length > 0 ? 'indigo darken-4' : ''
                    "
                  >
                    {{ selectedStoragesListIcon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("common.select_all") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0 && selectedAllStorages">
                <span>{{ $t("common.all") }}</span>
              </v-chip>
              <v-chip v-if="index === 0 && !selectedAllStorages">
                <span>{{ item.name }}</span>
              </v-chip>
              <span
                  v-if="index === 1 && !selectedAllStorages"
                  class="grey--text text-caption"
              >
                (+{{ selectedStoragesList.length - 1 }} )
              </span>
            </template>
          </v-select>
        </v-card>
      </v-col>
    </v-row>
    <v-data-table
      ref="goodsIncomingTable"
      :headers="goodsRemainsTableHeader.filter((item)=>{
          return (!item.only_lang) || (item.only_lang && item.only_lang === this.lang)
        })"
      :items="goods_remains"
      class="elevation-0 mb-3 w-100"
      :loading="!fetched"
      :disabled="!fetched"
      @update:options="
        (options) => {
          setTableOptions(options);
          getGoodsRemains();
        }
      "
      :server-items-length="itemsTotalCount"
      :options="tableOptions"
      :height="tableHeight"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:[lastHeaderElement]="props">
        {{ props.header.text }}
        <table-config-btn :table="tableName" :default-columns="defaultGoodsRemainsTableHeader"/>
      </template>
      <template v-slot:header.avito_export_price="props">
        <v-icon class="mr-2">$avito</v-icon>{{props.header.text}}
      </template>
      <template v-slot:header.zzap_export_price="props">
        <v-icon class="mr-2">$zzap</v-icon>{{props.header.text}}
      </template>
      <template v-slot:header.ozon_export_price="props">
        <v-icon class="mr-2">$ozon</v-icon>{{props.header.text}}
      </template>
      <template v-slot:item.brand="props">
        <span class="dashed pointer" @click="showNomenclatureWindow(props.item)">
          {{props.item.brand}}
        </span>

      </template>
      <template v-slot:item.price="props">
        <span class="text-no-wrap">{{ formatCurrency(props.item.price) }}</span>
      </template>
      <template v-slot:item.price_with_margin="props">
        <span class="text-no-wrap">{{ formatCurrency(props.item.price_with_margin) }}</span>
      </template>
      <template v-slot:item.avito_export_price="props">
        <span v-if="props.item.nomenclature_id !== nowProcessingItemWithId">
          {{getExportPrice(props.item, 'avito')}}
        </span>
        <nomenclature-export-price-menu
            :is-loading="props.item.nomenclature_id === nowProcessingItemWithId"
            :show.sync="exportPriceMenu['avito'+props.item.id]"
            :export-price="props.item.avito_export_price"
            @set-price="(price)=>setExportPrice(price, 'avito', props.item)"
        />

      </template>
      <template v-slot:item.zzap_export_price="props">
        {{getExportPrice(props.item, 'zzap')}}
        <nomenclature-export-price-menu
            :is-loading="props.item.nomenclature_id === nowProcessingItemWithId"
            :show.sync="exportPriceMenu['zzap'+props.item.id]"
            :export-price="props.item.zzap_export_price"
            @set-price="(price)=>setExportPrice(price, 'zzap', props.item)"
        />
      </template>
      <template v-slot:item.ozon_export_price="props">
        {{getExportPrice(props.item, 'ozon')}}
        <nomenclature-export-price-menu
            :is-loading="props.item.nomenclature_id === nowProcessingItemWithId"
            :show.sync="exportPriceMenu['ozon'+props.item.id]"
            :export-price="props.item.ozon_export_price"
            @set-price="(price)=>setExportPrice(price, 'ozon', props.item)"
        />
      </template>
      <template v-slot:item.status="props">
        <goods-movement-basis-status :item="props.item" />
      </template>
      <template v-slot:item.amount_calculated="props">
        <template v-if="props.item.unit_is_divisible && props.item.unit_is_divisible===1">
            {{ props.item.amount_calculated }}
        </template>
        <template v-else>
          {{ props.item.amount_calculated.toString().replace('.000', '') }}
        </template>
        <template v-if="props.item.unit_name">
        {{ $t('goods.units_of_measurements.'+props.item.unit_name+'.short') }}
        </template>
      </template>
      <template v-slot:item.goods_movement_document_type.name="props">
        <span v-if="props.item.goods_movement_document_type">
          {{
            $t(
              "movementDocumentTypes.full." +
                props.item.goods_movement_document_type.name
            )
          }}
        </span>
      </template>
      <template v-slot:item.actions="props">
        <span class="btn-td-wrap">
          <v-btn
            elevation="0"
            min-width="36"
            min-height="36"
            color="primary"
            class="mb-0 ml-3 px-0 white--text"
            @click="showRemainsInfoForm(props.item)"
          >
            <v-icon small>fa-info-circle</v-icon>
          </v-btn>
        </span>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    <remains-info-form :show="remainsInfoForm.isVisible" @hide="remainsInfoForm.isVisible=false; remainsInfoForm.id=null" :id="remainsInfoForm.id"></remains-info-form>
    <nomenclature-form
        :id="nomenclatureWindow.id"
        :show="nomenclatureWindow.isVisible"
        :action="nomenclatureWindow.action"
        @hide="nomenclatureWindow.isVisible = false"
        @store="(items) => selectGoodsNomenclatureSearchItems(items)"
        @update="() => getGoodsRemains()"
    />

  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import GoodsMovementBasisStatus from "../../components/storage/GoodsMovementBasisStatus";
import RemainsInfoForm from "../../components/storage/RemainsInfoForm";
import CommonMixin from "@/mixins/common";
import TableConfigBtn from "@/components/common/TableConfigBtn";
import NomenclatureForm from "@/components/storage/NomenclatureForm.vue";
import NomenclatureExportPriceMenu from "@/components/storage/NomenclatureExportPriceMenu.vue";

export default {
  components: {
    NomenclatureExportPriceMenu,
    NomenclatureForm, TableConfigBtn, RemainsInfoForm, GoodsMovementBasisStatus },
  mixins: [CommonMixin],
  data: () => ({
    getGoodsTimeoutId: null,
    selectedStoragesList: [],
    tableName: "goods_remains",
    tableHeight: "100",
    remainsInfoForm:{
      isVisible: false,
      id: null
    },
    findTimeoutId: null,
    nomenclatureWindow:{
      id:null,
      isVisible: false,
      action: null
    },
    nomenclatureExportPriceWindow: {
      id: null,
      storage_id: null,
      nomenclature_id: null,
      isVisible: false
    },
    exportPriceMenu:{}
  }),
  mounted() {
    this.getStorages().then(() => {
      this.fillStorages()
    });
  },
  methods: {
    getStorages() {
      return this.$store.dispatch("storages/get");
    },
    toggleSelectedStorages() {
      this.$nextTick(() => {
        if (this.selectedAllStorages) {
          this.selectedStoragesList = [];
        } else {
          this.selectedStoragesList = [];
          this.storages.forEach((storage) => {
            this.selectedStoragesList.push(storage);
          });
        }
      });
    },
    fillStorages() {
      let storageIds = [];
      if (this.$route.query.storages) {
        storageIds = this.$route.query.storages.split(",");
      }
      let selectedAll = storageIds.length === 0;
      this.storages.forEach((storage) => {
        if (selectedAll || storageIds.includes(storage.id + "")) {
          if( ! this.selectedStoragesList.find((ex)=>storage.id===ex.id)) {
            this.selectedStoragesList.push(storage);
          }
        }
      });
    },
    getExportPrice(item, type){
      let storage_id = item.storage_id;
      let price = '';
      if(storage_id && item.nomenclature && item.nomenclature.min_amounts_by_storages && item.nomenclature.min_amounts_by_storages){
        let storages = item.nomenclature.min_amounts_by_storages;

        storages.forEach(storage=>{
          if(storage.id===storage_id){
            price = storage.pivot[type+'_export_price'];
            price = price ?  this.formatCurrency(price) : price;
          }
        })
      }
      return price;
    },
    async setExportPrice(price, type, item){
      let newPrice = await this.$store.dispatch("nomenclatures/setExportPrice", {
        price,
        type,
        storage_id: item.storage_id,
        id: item.nomenclature_id
      }).then((newPrice)=>{
        let storage_id = item.storage_id;
        if(storage_id && item.nomenclature && item.nomenclature.min_amounts_by_storages && item.nomenclature.min_amounts_by_storages){
          let min_amounts_by_storages = item.nomenclature.min_amounts_by_storages;
          let storage = min_amounts_by_storages.find((storage)=>storage.id === item.storage_id)
          if(storage){
            storage.pivot[type+'_export_price'] = newPrice;
          } else {
              //если у nomenclature не было min_amounts_by_storages для склада - создадим
              let tmpStorage = {
                id: item.storage_id,
                shop_id: item.shop_id,
                pivot: {
                  nomenclature_id: item.nomenclature.id,
                  storage_id: item.storage_id,
                }
              }
              tmpStorage.pivot[type+'_export_price'] = newPrice
              item.nomenclature.min_amounts_by_storages.push(tmpStorage)
          }
        }
      })
    },
    showNomenclatureWindow(item, action='update'){
      this.nomenclatureWindow.id = item.nomenclature_id;
      this.nomenclatureWindow.action=action;
      this.nomenclatureWindow.isVisible=true;
    },
    showRemainsInfoForm(item){
      this.remainsInfoForm.isVisible = true;
      this.remainsInfoForm.id = item.nomenclature_id
    },
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["goodsIncomingTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
    setTableOptions(options) {
      this.tableOptions = options;
    },
    getGoodsRemains() {
      this.$store.dispatch("tables_config/get").then(()=> {
        this.$store.dispatch("goods_remains/get",{
          storages: this.$route.query.storages
              ? this.$route.query.storages.split(",")
              : [],
        });
      })
    },
  },
  computed: {
    ...mapFields("storages", ["storages"]),
    ...mapFields("nomenclatures", ["nowProcessingItemWithId"]),
    ...mapFields("goods_remains", [
      "goods_remains",
      "tableOptions",
      "itemsTotalCount",
      "search",
      "fetched",
    ]),
    selectedAllStorages() {
      return this.storages.length === this.selectedStoragesList.length;
    },
    selectedStoragesListIcon() {
      if (this.selectedAllStorages) return "mdi-close-box";
      if (this.selectedStoragesList.length > 0) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    lastHeaderElement(){
      return 'header.'+(this.goodsRemainsTableHeader.slice(-1) && this.goodsRemainsTableHeader.slice(-1)[0] && this.goodsRemainsTableHeader.slice(-1)[0].value);
    },
    goodsRemainsTableHeader() {
      let tableHeaderConfig =  this.getConfiguredTableHeader(this.tableName, this.defaultGoodsRemainsTableHeader);
      return tableHeaderConfig.filter(item=>item.is_hidden!==true)
    },
    defaultGoodsRemainsTableHeader() {
      return [
        {
          text: this.$t("common.brand"),
          value: "brand",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.part_code"),
          value: "part_code",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.title"),
          value: "name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.amount"),
          value: "amount_calculated",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price"),
          value: "price",
          sortable: true,
          class: "text-no-wrap",
          align: "end",
        },
        {
          text: this.$t("common.price_with_margin"),
          value: "price_with_margin",
          sortable: true,
          class: "text-no-wrap",
          align: "end",
        },
        {
          text: this.$t("viewSettings.goods_export.price_for_avito"),
          value: "avito_export_price",
          sortable: true,
          class: "text-no-wrap",
          align: "end",
          only_lang: "ru"
        },
        {
          text: this.$t("viewSettings.goods_export.price_for_zzap"),
          value: "zzap_export_price",
          sortable: true,
          class: "text-no-wrap",
          align: "end",
          only_lang: "ru"
        },
        {
          text: this.$t("viewSettings.goods_export.price_for_ozon"),
          value: "ozon_export_price",
          sortable: true,
          class: "text-no-wrap",
          align: "end",
          only_lang: "ru"
        },
        {
          text: this.$t("viewGoods.storage"),
          value: "storage_name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack"),
          value: "storage_rack_name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack_shelve"),
          value: "storage_shelf_name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          width: "150px",
          text: "",
          sortable: false,
          class: "text-no-wrap flex-nowrap justify-space-between",
          is_action_column: true,
          value: "actions"
        },
      ];
    },
  },
  watch:{
    '$route.query'(to, from){
      if(to.storages!==from.storages){
        this.fillStorages();
        this.$nextTick(() => {
          this.getGoodsRemains();
        });
      }
    },
    search(to) {
      clearTimeout(this.findTimeoutId);
      this.findTimeoutId = setTimeout(() => {
        this.getGoodsRemains();
      }, 1000);
    },
    selectedStoragesList(to) {
      clearTimeout(this.getGoodsTimeoutId);
      this.getGoodsTimeoutId = setTimeout(() => {
        let storages = [];
        if (to.length === 0) {
          storages = [];
        } else {
          to.forEach((storage) => {
            storages.push(storage.id);
          });
        }
        if (storages.length !== this.storages.length && (this.$route.query.storages !== storages.join(",") + "")) {
            this.$router.push({ path: "/storage", query: { storages: storages.join(",") } })
        }
        if(storages.length === this.storages.length){
          this.$router.push({ path: "/storage"})
        }
      }, 1000);
    },
  }
};
</script>

<style></style>
